import { render, staticRenderFns } from "./ProcedimientosCountersSection.vue?vue&type=template&id=e475694c"
import script from "./ProcedimientosCountersSection.vue?vue&type=script&lang=js"
export * from "./ProcedimientosCountersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports